import {userActionTypes} from '../_constants';
import {stateInitializer} from "./stateInitializer";

// initial state for the reducer
const initialState = stateInitializer.getUserInitialStates();

export function users(state = initialState, action) {
  switch (action.type) {

    // get current user request
    case userActionTypes.GET_USER_REQUEST:
      return {
        ...state,
        info: {
          loading: true
        }
      };

    // get user success
    case userActionTypes.GET_USER_SUCCESS:
      return {
        ...state,
        info: {
          details: action.user
        }
      };

    // get user failure
    case userActionTypes.GET_USER_FAILURE:
      return {
        ...state,
        info: {
          error: action.error
        }
      };

      // set payment for user - success
    case userActionTypes.SET_PAYMENT_SUCCESS:
      return {
        ...state,
        payment: {
          loading: false
        }
      };

      // set payment for user - failure
    case userActionTypes.SET_PAYMENT_FAILURE:
      return {
        ...state,
        payment: {
          error: action.error
        }
      };

      // set payment for user - request
    case userActionTypes.SET_PAYMENT_REQUEST:
      return {
        ...state,
        payment: {
          loading: true
        }
      };

      // password change token generation - request
    case userActionTypes.PASSWORD_TOKEN_REQUEST:
      return {
        ...state,
        passwordGenerate:{
          loading: true
        }
      };

      // password change token generation - request
    case userActionTypes.PASSWORD_TOKEN_SUCCESS:
      return {
        ...state,
        passwordGenerate:{
          loading: false,
          completed: true
        }
      };

      // password change token generation - failure
    case userActionTypes.PASSWORD_TOKEN_FAILURE:
      return {
        ...state,
        passwordGenerate:{
          loading: false,
          completed: false
        }
      };

      // password change process - request
    case userActionTypes.PASSWORD_RESET_REQUEST:
      return {
        ...state,
        passwordReset:{
          loading: true
        }
      };

      // password change process - success
    case userActionTypes.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        passwordReset:{
          loading: false,
          completed: true
        }
      };

      // password change process - failure
    case userActionTypes.PASSWORD_RESET_FAILURE:
      return {
        ...state,
        passwordReset:{
          loading: false,
          completed: false
        }
      };

      // password change process - request
    case userActionTypes.PASSWORD_CHANGE_REQUEST:
      return {
        ...state,
        passwordChange:{
          loading: true
        }
      };

      // password change process - success
    case userActionTypes.PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        passwordChange:{
          loading: false,
          completed: true
        }
      };

      // password change process - failure
    case userActionTypes.PASSWORD_CHANGE_FAILURE:
      return {
        ...state,
        passwordChange:{
          loading: false,
          completed: false
        }
      };

      // account cancellation - request
    case userActionTypes.CANCEL_ACCOUNT_REQUEST:
      return {
        ...state,
        accountCancellation:{
          isLoading: true
        }
      };

      // account cancellation - success
    case userActionTypes.CANCEL_ACCOUNT_SUCCESS:
      return {
        accountCancellation: {
          isSuccess: true
        }
      };

      // account cancellation - failure
    case userActionTypes.CANCEL_ACCOUNT_FAILURE:
      return {
        ...state,
        accountCancellation:{
          isSuccess: false
        }
      };

    default:
      return state
  }
}